import React from 'react';
import { motion } from 'framer-motion';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
  children: React.ReactNode;
}
export function Button({
  variant = 'primary',
  fullWidth = false,
  children,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-lg font-medium transition-all duration-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-[#0f172a]';
  const variants = {
    primary: 'bg-[#d4a574] hover:bg-[#c9a86c] text-[#0f172a] shadow-[0_0_15px_rgba(212,165,116,0.3)] hover:shadow-[0_0_25px_rgba(212,165,116,0.5)]',
    secondary: 'bg-[#1e1b4b] hover:bg-[#2e2a5b] text-[#d4a574] border border-[#d4a574]/30',
    outline: 'bg-transparent border border-[#d4a574] text-[#d4a574] hover:bg-[#d4a574]/10'
  };
  const handleClick = () => {
    const discountBadge = document.getElementById('discount-badge');
    if (discountBadge) {
      discountBadge.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  };
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} onClick={handleClick} {...props} data-id="element-192">
      {children}
    </motion.button>;
}